var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardWrap',_vm._b({staticClass:"CardDefault"},'CardWrap',_vm.$props,false),[_c('div',[_vm._v("This is a default render for unknown card type ("+_vm._s(_vm.card.card_type_id)+")")])])}
var staticRenderFns = []

export { render, staticRenderFns }